import { useEffect, useState } from "react";
import { fetchCities } from "./busApi";

export function useCities() {
  const [cities, setCities] = useState([]);
  const [cityMap, setCityMap] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCities()
.then((data) => {
  const list = Array.isArray(data) ? data : data.cities || [];

  setCities(list);

  const map = {};
  list.forEach((c) => {
    map[c.name.toLowerCase()] = c.id;
  });

  setCityMap(map);
})
      .catch((err) => console.error("Cities fetch error:", err))
      .finally(() => setLoading(false));
  }, []);

  const getCityId = (cityStr) => {
    if (!cityStr || !cities.length) return null;
    const full = cityStr
  .replace(/\s*\(.*?\)/, "")
  .trim()
  .toLowerCase();
    const firstPart = cityStr.split(",")[0].trim().toLowerCase();
    if (cityMap[full])      return cityMap[full];
    if (cityMap[firstPart]) return cityMap[firstPart];
    const exact = cities.find(
      (c) => c.name.toLowerCase() === full || c.name.toLowerCase() === firstPart
    );
    if (exact) return exact.id;
    const startsWith = cities.find((c) => {
      const name = c.name.toLowerCase();
      return (
        name === firstPart ||
        name.startsWith(firstPart + " ") ||
        name.startsWith(firstPart + "(") ||
        name.startsWith(firstPart + ",")
      );
    });
    if (startsWith) return startsWith.id;
    const fuzzy = cities.find((c) => c.name.toLowerCase().includes(firstPart));
    return fuzzy?.id || null;
  };

  const getAllCities = () => cities.map((c) => c.name);

  return { cities, getCityId, getAllCities, loading };
}